/**
 * zl-readmore.js
 * Universal read more / read less toggle.
 *
 * The __body element is pre-rendered in Liquid with the correct
 * --clamped and --lines-N classes already applied. JS only attaches
 * the toggle button and handles clicks. No DOM measurement, no
 * height calculation, no flash.
 *
 * Usage (rendered by Liquid):
 *   <div class="zl-readmore" data-more="Read more" data-less="Read less">
 *     <div class="zl-readmore__body zl-readmore__body--clamped zl-readmore__body--lines-2">
 *       content here
 *     </div>
 *   </div>
 *
 * Loaded via theme.liquid:
 *   <script src="{{ 'zl-readmore.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var CHEVRON_SVG =
    '<svg class="zl-readmore__chevron" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function initInstance(container) {
    if (container.dataset.zlRmInit === 'true') return;
    container.dataset.zlRmInit = 'true';

    var moreLabel = container.dataset.more || 'Read more';
    var lessLabel = container.dataset.less || 'Read less';

    // Body is pre-rendered in Liquid — do not re-wrap
    var body = container.querySelector('.zl-readmore__body');
    if (!body) return;

    // Create toggle button
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'zl-readmore__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<span class="zl-readmore__toggle-text">' + moreLabel + '</span>' +
      CHEVRON_SVG;
    container.appendChild(toggle);

    // Click handler — pure class + attribute toggle
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        body.classList.add('zl-readmore__body--clamped');
        body.classList.remove('zl-readmore__body--expanded');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.querySelector('.zl-readmore__toggle-text').textContent = moreLabel;
      } else {
        body.classList.remove('zl-readmore__body--clamped');
        body.classList.add('zl-readmore__body--expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.querySelector('.zl-readmore__toggle-text').textContent = lessLabel;
      }
    });
  }

  function initAll() {
    var containers = document.querySelectorAll('.zl-readmore');
    for (var i = 0; i < containers.length; i++) {
      initInstance(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    if (document.readyState === 'complete') {
      initAll();
    } else {
      window.addEventListener('load', initAll);
    }
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 100);
  });

})();